let DEBUG = true //调试模式

let RENDER_TYPE = {
    CALCULATOR: {
        ADD : "ADD",
        SUBTRACT : "SUBTRACT",
        MULTIPLY : "MULTIPLY",
        DIVIDE : "DIVIDE",
        CUSTOM : "CUSTOM"
    },
    SELECT : "SELECT", //下拉框
    CHECKBOX: "CHECKBOX",//多选
    RADIO: "RADIO",//单选
    INPUT: "INPUT",//输入框
    DATE: "DATE", //日期
    NUMBER: "NUMBER",//数字输入框
    DISPLAY: "DISPLAY", //隐藏
    ACTION: "ACTION",//操作
    CLICK:"CLICK",//点击
    MONEY:"MONEY"

}

let EDIT_PERMISSIONS = {
    READ_ONLY:true
}

let SEARCH_COMPONENT_TYPE = {
    SELECT:"SELECT",
    CUSTOM_SELECT:"CUSTOM_SELECT",
    INPUT:"INPUT",
    DATE_PICKER:"DATE_PICKER",
    NUMBER: "NUMBER",
}


//日期格式化
const dateFormat = (date, fmt) => {
    if(!date){
        return ""
    }
    date = new Date(date)
    var a = ['日', '一', '二', '三', '四', '五', '六']
    var o = {
        'M+': date.getMonth() + 1, // 月份
        'd+': date.getDate(), // 日
        'h+': date.getHours(), // 小时
        'H+': date.getHours(), // 小时
        'm+': date.getMinutes(), // 分
        's+': date.getSeconds(), // 秒
        'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
        'S': date.getMilliseconds(), // 毫秒
        'w': date.getDay(), // 周
        'W': a[date.getDay()], // 大写周
        'T': 'T'
    }
    if (/(y+)/.test(fmt)) { fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length)) }
    for (var k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) { fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length))) }
    }
    return fmt
}

export default {
    DEBUG,
    RENDER_TYPE,
    EDIT_PERMISSIONS,
    SEARCH_COMPONENT_TYPE,
    dateFormat,
}







